import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import css from './IconChatList.module.css';

const IconChatList = props => {
  const { className, rootClassName } = props;
  const classes = clsx(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className={css.strokeMatter} fill="none" fillRule="evenodd" strokeLinejoin="round"></g>
      <path d="M3.54,13A.52.52,0,0,1,3,12.49H3l0-2H1.76A1.75,1.75,0,0,1,0,8.69V1.84A1.72,1.72,0,0,1,1.76.05H12.27a1.9,1.9,0,0,1,1.92,1.79V8.69a1.93,1.93,0,0,1-1.92,1.84H7.18L3.85,12.92A.5.5,0,0,1,3.54,13ZM1.76,1.1a.67.67,0,0,0-.67.74V8.69a.71.71,0,0,0,.67.79H3.61a.52.52,0,0,1,.52.53h0l0,1.44L6.71,9.58a.54.54,0,0,1,.3-.1h5.26a.88.88,0,0,0,.87-.79V1.84a.84.84,0,0,0-.87-.74Z" transform="translate(-0.04 -0.05)"/>
      <rect x="2.62" y="6.52" width="9.15" height="0.81" rx="0.23"/>
      <rect x="2.62" y="4.75" width="9.15" height="0.81" rx="0.23"/>
      <rect x="2.62" y="2.98" width="9.15" height="0.81" rx="0.23"/>
    </svg>
  );
};

const { string } = PropTypes;

IconChatList.defaultProps = {
  className: null,
  rootClassName: null,
};

IconChatList.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconChatList;
